import axiosInstance from "./AxiosInstance";
const calibrationUrl = "api/calibration";
const instrumentUrl = "api/instrument";

export function getcalibrationListApi(page, page_size, query) {
  const params = new URLSearchParams({
    page,
    page_size,
    query,
  });
  return axiosInstance.get(`${calibrationUrl}?${params.toString()}`);
}

export function getCalibrationApi(id) {
  return axiosInstance.get(`${calibrationUrl}/${id}`);
}

export function createcalibrationApi(data) {
  return axiosInstance.post(calibrationUrl, data);
}

export function updatecalibrationApi(id, data) {
  return axiosInstance.put(`${calibrationUrl}/${id}`, data);
}

export function cancelledCalibrationpi(id, data) {
  return axiosInstance.patch(`${calibrationUrl}/${id}`, data);
}

export function getInstrumentListApi(page, page_size, query) {
  const params = new URLSearchParams({
    page,
    page_size,
    query,
  });
  return axiosInstance.get(`${instrumentUrl}?${params.toString()}`);
}

export function getInstrumentApi(id) {
  return axiosInstance.get(`${instrumentUrl}/${id}`);
}

export function createInstrumentApi(data) {
  return axiosInstance.post(instrumentUrl, data);
}

export function updateInstrumentApi(data) {
  return axiosInstance.put(instrumentUrl, data);
}

export function getInstrument() {
  return axiosInstance.get(`api/search_instrument`);
}

export function createCalibrationReport(data) {
  return axiosInstance.post("api/calibration_report", data);
}


